import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import type {History} from 'history';

import user from './user/user-slice';
import reports from 'pages/reports/store/reports-slice';
import facilities from 'pages/facilities/store/facilities-slice';
import driverFeedback from 'pages/facilities/driver-feedback/store/driver-feedback-slice';
import accounting from 'pages/accounting/store/accounting-slice';
import blackouts from 'pages/blackouts/store/blackouts-slice';
import spotheroIQ from 'pages/rates/spothero-iq/store/spothero-iq-slice';
import reservations from 'pages/reservations/store/reservations-slice';
import compPass from 'pages/comp-pass/store/comp-pass-slice';
import comparativeSnapshot from 'pages/rates/comparative-snapshot/store/comparative-snapshot-slice';
import inventory from 'pages/inventory/store/inventory-slice';
import events from 'pages/event-management/store/events-reducer';
import flexRates from 'pages/rates/flex-rates/store/flex-rates-slice';
import dashboard from 'pages/dashboard/store/dashboard-slice';
import monthlyRates from 'pages/rates/monthly/store/monthly-rates-slice';
import experiments from './experiments/experiments-slice';
import employeeParking from 'pages/employee-parking/store/employee-parking-slice';
import changelog from 'pages/changelog/store/changelog-slice';

/**
 * Creates the root reducer for the application.
 *
 * @memberof module:store
 */
export default (history: History) =>
    combineReducers({
        user,
        reports,
        blackouts,
        facilities,
        driverFeedback,
        spotheroIQ,
        accounting,
        reservations,
        comparativeSnapshot,
        experiments,
        inventory,
        flexRates,
        monthlyRates,
        events,
        dashboard,
        compPass,
        employeeParking,
        changelog,
        router: connectRouter(history),
    });
